"use client";

import React from "react";
import { Search, X } from "lucide-react";
import { Loader, FieldError } from "../index";

import "./SearchInput.css";

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    autoFocus?: boolean;
    hasError?: boolean;
    errorMessage?: string | null;
    size?: "sm" | "md" | "lg";
    disabled?: boolean;
    loading?: boolean;
    maxLength?: number;
    name?: string;
    type?: string;
    ariaLabel?: string;
    onSubmit?: () => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
    value,
    onChange,
    placeholder = "Search...",
    className = "",
    autoFocus = false,
    hasError = false,
    errorMessage,
    size = "md",
    disabled = false,
    loading = false,
    maxLength,
    name,
    type = "text",
    ariaLabel,
    onSubmit,
}) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && onSubmit && !disabled) {
            onSubmit();
        }
    };

    return (
        <div className={`search-input-wrapper ${className} search-input--${size}
      ${hasError ? "has-error" : ""}
      ${value ? "is-focused" : ""}
      ${disabled ? "is-disabled" : ""}
    `}>
            <div className="search-input-inner">
                <Search className="search-input-icon" size={18} />
                <input
                    type={type}
                    name={name}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    autoFocus={autoFocus}
                    disabled={disabled}
                    maxLength={maxLength}
                    aria-label={ariaLabel}
                    onKeyDown={handleKeyDown}
                    className="search-input-field"
                />
                {loading ? (
                    <div className="search-input-loading">
                        <Loader variant="circle" color="glory" size="sm" />
                    </div>
                ) : (
                    value && !disabled && (
                        <button
                            type="button"
                            className="search-input-clear"
                            onClick={() => onChange("")}
                            aria-label="Clear search"
                        >
                            <X size={16} />
                        </button>
                    )
                )}
            </div>

            {hasError && errorMessage && (
                <FieldError>{errorMessage}</FieldError>
            )}

        </div>
    );
};

export default SearchInput;
